import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { take } from 'rxjs/operators';
import { ContratosApi } from '../shared/api/contratos.api';
import { Contrato } from '../shared/models/contrato.model';
import { LoginInformation } from '../shared/models/login-information.model';
import { Parcela } from '../shared/models/parcela.model';
import { AutenticacaoService } from './../seguranca/autenticacao.service';
import { StatusParcelaEnum } from './../shared/enums/status-parcela.enum';
import { LoaderService } from './../shared/loader/loader.service';
import { SegundaViaResponse } from './../shared/models/segunda-via-response.model';
import { StepperNavigationService } from './../shared/services/stepper-navigation.service';

/**
 * @title Stepper overview
 */
@Component({
  selector: 'app-stepper-overview',
  templateUrl: './stepper-overview.component.html',
  styleUrls: ['./stepper-overview.component.scss'],
})
export class StepperOverviewComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;

  formGroupContratos: FormGroup;
  secondFormGroup: FormGroup;

  contratos: Array<Contrato>;
  contratoSelecionado: Contrato;

  parcelaSelecionada: Parcela;

  dadosSegundaVia: SegundaViaResponse;
  showAlertBoleto = false;

  userInformation: LoginInformation;

  isMobileDevice = false;
  hasCompleted = false;

  constructor(
    private formBuilder: FormBuilder,
    private autenticacaoService: AutenticacaoService,
    private contratosApi: ContratosApi,
    private loaderService: LoaderService,
    private stepperNavigationService: StepperNavigationService
  ) { }

  ngOnInit() {
    this.formGroupContratos = this.formBuilder.group({
      contratoSelecionado: ['', Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      parcelaSelecionada: ['', Validators.required]
    });

    this.getContratos(this.autenticacaoService.autenticacao.cpfCliente);
  }

  private getContratos(cpf: string): void {
    this.loaderService.start();

    this.contratosApi.getContratos(cpf)
      .pipe(take(1))
      .subscribe((contratos: Array<Contrato>) => {
        this.contratos = contratos;
        this.loaderService.stop();
      });
  }

  private gerarSegundaVia(): void {

    this.hasCompleted = true;

    if (
      this.parcelaSelecionada.statusParcela === StatusParcelaEnum.STATUS_VENCIDA ||
      this.parcelaSelecionada.statusParcela === StatusParcelaEnum.STATUS_ACORDO_RENEGOCIADO
    ) {
      this.showAlertBoleto = true;
    } else {
      this.showAlertBoleto = false;
    }

    this.loaderService.start();
    this.contratosApi.getSegundaVia(this.contratoSelecionado.contrato, this.parcelaSelecionada.numeroParcela)
      .pipe(take(1))
      .subscribe((segundaVia: SegundaViaResponse) => {
        this.dadosSegundaVia = segundaVia;
        this.loaderService.stop();
      });
  }

  setContratoSelecionado(contratoSelecionado: Contrato): void {
    this.contratoSelecionado = contratoSelecionado;
    this.formGroupContratos.controls.contratoSelecionado.setValue(contratoSelecionado);
    this.stepperNavigationService.goForward(this.stepper);
  }

  setParcelaSelecionada(parcelaSelecionada: Parcela): void {
    this.parcelaSelecionada = parcelaSelecionada;
    this.secondFormGroup.controls.parcelaSelecionada.setValue(parcelaSelecionada);
    this.stepperNavigationService.goForward(this.stepper);
    this.gerarSegundaVia();
  }

  get hasContratos(): boolean {
    return this.contratos && this.contratos.length > 0;
  }

  get noHasContratos(): boolean {
    return (!this.contratos || this.contratos.length <= 0);
  }

  get isMobile(): boolean {
    return (window.innerWidth < 600);
  }

  resetAll(): void {
    this.parcelaSelecionada = null;
    this.showAlertBoleto = false;
    this.hasCompleted = false;
    this.stepperNavigationService.reset(this.stepper);
  }

}
